export default "__VITE_ASSET__e197170f__"